import { fetchSiteInfo } from '@/services/sheets'

const DEFAULTS = {
    artist_name: 'Иван Мясников',
    vk_art: 'https://vk.com/ivanmyasnikov_art',
    vk_ivanovo_pole: 'https://vk.com/ivanovo_pole',
    instagram: 'https://instagram.com/ivan._.myasnikov',
}

export default {
    namespaced: true,

    state: () => ({
        data: { ...DEFAULTS },
        loading: false,
        loaded: false,
    }),

    getters: {
        get: state => key => state.data[key] || '',
        artistName: state => state.data.artist_name || 'Иван Мясников',
        artistBio: state => state.data.artist_bio || '',
        artistQuote: state => state.data.artist_quote || '',
        phoneRaw: state => {
            const raw = (state.data.phone || '').trim()
            if (!raw) return ''
            const digits = raw.replace(/[^\d]/g, '')
            if (!digits) return ''
            return '+' + (digits.startsWith('8') ? '7' + digits.slice(1) : digits)
        },
        phone: (state, getters) => {
            const raw = getters.phoneRaw
            if (!raw) return ''
            const d = raw.replace(/[^\d]/g, '')
            if (d.length === 11) {
                return `+${d[0]} (${d.slice(1,4)}) ${d.slice(4,7)}-${d.slice(7,9)}-${d.slice(9,11)}`
            }
            return raw
        },
        vkArt: state => state.data.vk_art || '',
        vkIvanovoPole: state => state.data.vk_ivanovo_pole || '',
        instagram: state => state.data.instagram || '',
        boosty: state => state.data.boosty || '',
        artistPhoto: state => state.data.artist_photo || '',
        teachingPhoto: state => state.data.teaching_photo || '',
    },

    mutations: {
        SET_DATA(state, data) { state.data = { ...DEFAULTS, ...data } },
        SET_LOADING(state, val) { state.loading = val },
        SET_LOADED(state, val) { state.loaded = val },
    },

    actions: {
        async fetch({ commit, state }) {
            if (state.loaded) return
            commit('SET_LOADING', true)
            try {
                const data = await fetchSiteInfo()
                if (data && Object.keys(data).length > 0) {
                    commit('SET_DATA', data)
                }
                commit('SET_LOADED', true)
            } catch (e) {
                console.error('[Store:siteInfo]', e)
            } finally {
                commit('SET_LOADING', false)
            }
        }
    }
}
